






























































import {Component, Prop, Vue} from 'vue-property-decorator';
import OptionSideBar from '@/layouts/gripper/components/QuickLabeling/OptionSideBar.vue';
import ImagesGrid from '@/layouts/gripper/components/QuickLabeling/ImagesGrid.vue';
import TaskElaboration from './components/TaskElaboration.vue';
import {Option, ReviewResource} from '@/types/gripper';
import {
  PipelineInfo,
  PipelineInfo_pipeline_parameter,
  PipelineResources, PipelineResources_resources_data, PipelineResourcesVariables,
} from '@/types/intrador';
import MessageCategoryIsDone from '@/layouts/gripper/components/MessageCategoryIsDone.vue';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import PaginateButtonsWithMin from '@/layouts/gripper/components/PaginateButtonsWithMin.vue';

@Component({
  components: {
    DirectionSwitch,
    MessageCategoryIsDone,
    TaskElaboration,
    ImagesGrid,
    OptionSideBar,
    IntradorLoader,
    PaginateButtonsWithMin,
  },
  metaInfo: {
    title: 'Quick Reviewing',
  },
})

export default class QuickReviewing extends Vue {

  get queryVariables() {
    const ret = {
      optionId: this.selectedParameterOption?.id,
      pipelineId: this.pipelineInfo?.pipeline.id,
      parameterId: this.parameter?.id,
      limit: this.limit,
      page: this.page,
    } as PipelineResourcesVariables;
    if (this.minId) {
      ret.minId = this.minId;
      ret.page = 1;
    }
    return ret;
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  @Prop(Object) public pipelineInfo!: PipelineInfo;
  @Prop(Array) public options!: Option[];
  @Prop(Object) public selectedParameterOption!: Option;
  @Prop(Object) private parameter!: PipelineInfo_pipeline_parameter;

  private pipelinePrediction!: PipelineResources;

  private isDragging: boolean = false;

  private imagesData: ReviewResource[] = [];

  private page: number = 1;
  private minId: number | null = null;
  private limit: number = 32;
  private remaining: number = 0;
  private offset: number = this.limit;

  public async persistAllToDB() {
    await Promise.all(this.imagesData
      .filter((resource: ReviewResource) => {
        return !resource.isSelected;
      })
      .map(async (resource: ReviewResource) => {
        await this.removeCheck(resource);
      }));
  }

  private created() {
    window.addEventListener('mousedown', this.dragEnable);
    window.addEventListener('mouseup', this.dragDisable);
  }

  private dragEnable(event: MouseEvent) {
    this.isDragging = true;
  }

  private dragDisable(event: MouseEvent) {
    this.isDragging = false;
  }

  private refetch() {
    if (this.queryResult) {
      this.queryResult.refresh();
    }
  }

  private getTotalPages() {
    return Math.ceil((this.offset + this.remaining) / this.limit);
  }

  private getCurrentPage() {
    return Math.ceil(this.offset / this.limit);
  }

  private resolveData(data: PipelineResources) {
    this.pipelinePrediction = data;

    if (data.resources) {
      if (this.minId) {
        this.remaining = data.resources.paginatorInfo.total - this.limit;
      } else {
        this.remaining = data.resources.paginatorInfo.total - this.offset;
      }
    }
    this.resolveImagesData(data);

    return data;
  }

  private resolveImagesData(data: PipelineResources) {
    if (!data.resources) {
      return false;
    }
    this.imagesData = [];

    data.resources.data.forEach((item: PipelineResources_resources_data) => {
      if (this.imagesData.findIndex((i: ReviewResource) => i.id === item.id) < 0) {

        if (item.checks && item.predictions) {
          const resource: ReviewResource = {
            id: item.id,
            url: item.url,
            checkId: item.checks[0].id,
            predId: item.predictions[0].id,
            isSelected: true,
            isMutating: false,
            isDeleted: false,
            type: item.type,
          };
          this.imagesData.push(resource);
        }
      }
    });
  }

  private changeOption(option: Option) {
    this.minId = null;
    this.offset = this.limit;
    this.page = 1;

    this.$emit('onClickChangeLabel', option);
    this.refetch();
  }

  private markResource(resource: ReviewResource) {
    // mark the resouce as remove (set option to null) or set resource to belong to the current selected label
    resource.isSelected = !resource.isSelected;
    this.removeCheck(resource);
  }

  private async removeCheck(resource: ReviewResource) {
    resource.isMutating = true;

    this.$apollo.mutate({
      mutation: require('@/graphql/mutations/DeleteCheck.graphql'),
      variables: {
        id: resource.checkId,
      },
    }).catch((error) => {
      this.$swal('Error', error.message, 'warning');
    });

    resource.isMutating = false;
    this.offset = this.offset - 1;

    const indexInArray = this.imagesData.findIndex((i: any) => i.id === resource.id);

    this.imagesData = this.imagesData.filter((r: ReviewResource) => {
      return r.isSelected;
    });

    (this.$refs.imagesGrid as any).setSelectedResourceId(
      this.imagesData[Math.min(this.imagesData.length - 1, indexInArray)].id);

    if (this.imagesData.length === 0) {
      this.refetch();
    }
  }

  private async pageChange(newPage: number) {
    if (newPage > this.getTotalPages()) {
      return;
    }
    if (newPage - this.page === 1) {
      this.minId = this.imagesData.reduce((res, resource: ReviewResource) => {
        return Math.max(parseInt(resource.id, 0), res);
      }, 0);
    } else {
      this.minId = null;
    }
    this.page = newPage < 1 ? 1 : newPage;
    this.offset = this.minId ? this.offset + this.limit : newPage * this.limit;
    this.imagesData = [];
    this.refetch();
  }
}
